import axios from 'axios';
import { msalInstance } from '../main';
import { apiScopes } from '../auth/authConfig';

const graphApi = axios.create({
    baseURL: 'https://graph.microsoft.com/v1.0',
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 15000,
});

// Request interceptor to add Graph API token
graphApi.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getActiveAccount();
        if (account) {
            try {
                const response = await msalInstance.acquireTokenSilent({
                    scopes: apiScopes.graph,
                    account: account,
                });
                config.headers.Authorization = `Bearer ${response.accessToken}`;
            } catch (error: any) {
                console.error('Graph token acquisition failed:', error);
                if (error.name === 'InteractionRequiredAuthError') {
                    await msalInstance.loginRedirect({
                        scopes: apiScopes.graph,
                        prompt: 'select_account'
                    });
                    throw new Error('Token expired, redirecting to login');
                }
                throw error;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor for error handling
graphApi.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            console.error('Graph API unauthorized');
            const account = msalInstance.getActiveAccount();
            if (account) {
                try {
                    // Try to refresh Graph token
                    await msalInstance.acquireTokenSilent({
                        scopes: apiScopes.graph,
                        account: account,
                        forceRefresh: true
                    });
                    // Retry the request
                    return graphApi.request(error.config);
                } catch (tokenError) {
                    console.error('Graph token refresh failed:', tokenError);
                    await msalInstance.loginRedirect({
                        scopes: apiScopes.graph,
                        prompt: 'select_account'
                    });
                }
            }
        }
        return Promise.reject(error);
    }
);

export default graphApi;